<template>
  <div class="background-parrilla"
       :style="{ height: `${height}px`}"
  >
    <v-carousel 
      v-model="selectedCarouselItem"
      :cycle="false"
      :show-arrows="false" 
      hide-delimiters
      :style="{ height: `${height}px`}"
    >
      <!--v-carousel-item
        v-for="(item,i) in images"
        :key="i"
        :src="item"
      /-->
      <v-carousel-item
        v-for="(item, i) in contents"
        :key="i"
        v-html="item.content"
      />
    </v-carousel>
  </div>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
export default {
  props: {
    parrilla: {
      type: String,
      default: `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`,
    },
    height: {
      type: [Number, String],
      default: 980,
    },
  },
  data: () => ({
    images: null,
    contents: null,
    selectedCarouselItem: null,
    timer: null,
    timeout: null,
  }),
  watch: {
    parrilla (v) {
      this.getImages()
    },
  },
  mounted () {
    this.getImages ()
    this.iniTimer()
  },
  beforeDestroy() {
    this.endTimer()
  },
  methods: {
    iniTimer() {
      this.timer = setInterval(this.getImages, 30 * 60000)
      //this.timer = setInterval(this.getImages, 3600000)
    },
    endTimer() {
      if (this.timeout) clearTimeout(this.timeout)
      if (this.timer) clearInterval(this.timer)
    },
    prepareMediaContent (type, url, duration) {
      if (!duration || duration.length === 0) duration = 1
      const content = type === 'mp4' ? `<video src="${url}" width="100%" height="980px" loop
            autoplay="autoplay" muted defaultmuted playsinline />`
        : `<img src="${url}" width="100%" height="980px">`
      return {
        content,
        duration,
        type
      }
        //return `<v-img src="${url}" height="607px" width="100%" />`
    },
    handleIntervalImage () {
      const content = this.contents[this.selectedCarouselItem]
      const duration = content ? content.duration * 1000 : 0
      //if (this.contents[this.selectedCarouselItem].type === 'mp4') return
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.handleChangeContent()
      }, duration)
    },
    handleChangeContent () {
      this.selectedCarouselItem = this.selectedCarouselItem < this.contents.length-1 ? this.selectedCarouselItem + 1 : 0
      this.handleIntervalImage () 
    },
    getImages () {
      /*this.contents = [
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/zjcVPZCG4sM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`,
        `<video id="VideoPlayer" src="https://www.dviewcontent.com/asset/9f794be0-d81c-11e7-8bbc-bfcffb4c8a70/7321fc00-dadf-11e9-8ed6-33d7c5ea1d5a.mp4" width="100%" height="607px"
            controls="true" autoplay="autoplay" loop="true" muted defaultmuted playsinline />`,
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/zjcVPZCG4sM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`,
      ]*/
      axios.get(this.parrilla)// && this.enterpariseTotemBackground !== undefined ? this.enterpriseTotemBackground : `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`)
        .then (response => {
          try {
            console.log('dg--')
            const that = this
            parseString (response.data, (err, results) => {
            // parsing to json
              /*
              that.images = []
              that.images = results.rss.channel.shift().item.map(item => {
                return item['media:content'].shift()['$'].url
              })//.filter(x => x.indexOf('.mp4') === -1)
              */
              that.contents = []
              that.contents = results.rss.channel.shift().item.map(item => {
                const { url, type, duration } = item['media:content'].shift()['$']
                return that.prepareMediaContent(type, url, duration)
              }).filter(x => x.type !== 'mp4')
              //console.log('_content', that.contents)

              if (that.contents.length === 0 ) return
              that.selectedCarouselItem = 0
              this.handleIntervalImage()
            })
          } catch (error) {
           console.log(error)
          }
        })
    },
  }
}
</script>
<style scoped>
.background-parrilla {
  position: relative;
  height: 100%;
}
</style>

